<template>
    <Paginate
        v-if="paginationExists"
        container-class="uik-pagination"
        :value="pagination.current_page"
        :next-text="$t('UIK.components.universal.table.paginate.next', 'Next')"
        :prev-text="$t('UIK.components.universal.table.paginate.previous', 'Previous')"
        :margin-pages="marginPages"
        :page-count="pagination.last_page"
        :page-range="pageRange"
        :click-handler="paginationClick"
    />
</template>

<script>
import Paginate from "vuejs-paginate"

export default {
    name: "UikPaginate",
    components: { Paginate },
    props: {
        // The resource to paginate
        resource: { type: [Object, null], required: true },
        // The resource to paginate
        maxPages: { type: [Number, null], default: null }
    },
    computed: {
        /**
         * Gets the pagination object from the resource
         */
        pagination () {
            return this.resource.state.pagination
        },
        /**
         * Returns true if there is more than one page to paginate
         */
        paginationExists () {
            return this.pagination.last_page > 1 && Object.keys(this.pagination).length > 0
        },
        /**
         * Returns number of pages to display
         */
        pageRange () {
            if (this.maxPages) return this.maxPages
            let range = 10
            if (screen.width <= 1024) range = 8
            if (screen.width <= 768) range = 4

            return range
        },
        /**
         * Returns margin between first, current and last page
         */
        marginPages () {
            let margin = 3
            if (screen.width <= 768) margin = 0

            return margin
        }
    },
    methods: {
        /**
         * Fetches the list on the clicked page
         */
        paginationClick (pageNum) {
            this.$emit("page-change", pageNum)
            this.resource.getList({ page: pageNum })
        }
    }
}
</script>

<style lang="scss">
.uik-pagination {
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 20px 0;
    li {
        display: inline-block;
        margin: 0 !important;
        border: solid 1px $borderColor;
        border-left: none;
        box-shadow: 0 1px 3px 0 rgba(0, 0, 0, 0.04);
        overflow: hidden;
        a {
            display: inline-flex;
            align-items: center;
            justify-content: center;
            min-width: 32px;
            padding: 6px 12px;
            font-size: 14px;
            line-height: 17px;
            text-align: center;
            background-color: white;
            color: $textMain;
            user-select: none;
            outline: solid 1px transparent !important;
            transition: all 0.15s;
            &:hover {
                text-decoration: none;
                background-color: $primary;
                color: white;
                border-color: $primary;
            }
            &:active {
                background-color: rgba($primary, 0.8);
            }
        }
    }
    li:first-child {
        border-radius: 3px 0 0 3px;
        border-left: solid 1px $borderColor;
        a {
            color: $textMain;
            &:hover {
                color: white;
            }
        }
    }
    li:last-child {
        border-radius: 0 3px 3px 0;
        a {
            color: $textMain;
            &:hover {
                color: white;
            }
        }
    }
    li.active {
        a {
            color: $primary;
            font-weight: bold;
            &:hover {
                background-color: white;
                outline-color: transparent !important;
            }
        }
    }
    li.disabled {
        a {
            color: $textLight;
            &:hover {
                background-color: white;
                outline-color: transparent !important;
                color: $textLight;
            }
        }
    }
    @media only #{$mediaMobile} {
        li.disabled {
            display: none;
        }
    }
}
</style>
